export const modesButtons = {
  rack: ['regular', 'emergency', 'free', 'test'],
  app: ['regular', 'blocked'],
};

export const modes = {
  rack: {
    regular: 'Штатный',
    offline: 'Отключен',
    test: 'Сервисный',
    free: 'Свободный',
    emergency: 'Блокированный',
  },
  app: {
    regular: 'Штатный',
    offline: 'Отключен',
    blocked: 'Блокированный',
    emergency: 'Ошибка',
    app_not_work: 'Ошибка оборудования АПП',
  },
};

export const helpItems = {
  rack: [
    {
      icon: '/images/normal.svg',
      title: 'Штатный',
      info: 'Работа устройства в соответствии с алгоритмами системы',
    },
    {
      icon: '/images/blocked.svg',
      title: 'Блокированный',
      info: 'Оборудование выключено, проезд закрыт, шлагбаум опущен',
    },
    {
      icon: '/images/free.svg',
      title: 'Свободный',
      info: 'Проезд открыт, шлагбаум поднят, для проезда ТС в экстренных случаях',
    },
    {
      icon: '/images/service.svg',
      title: 'Сервисный',
      info: 'Тестирование системы, шлагбаумы поднимаются при въезде автомобиля на индукционную петлю',
    },
  ],
  app: [
    {
      icon: '/images/normal.svg',
      title: 'Штатный',
      info: 'Работа устройства в соответствии с алгоритмами системы',
    },
    {
      icon: '/images/blocked.svg',
      title: 'Блокированный',
      info: 'Платежный терминал заблокирован оператором',
    },
  ],
};
